/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Link } from 'gatsby';
// Packages
import { Row, Container, Col } from 'react-bootstrap';
// Icons
import {
  RiLinkedinBoxLine,
  RiCopyrightLine,
  RiPhoneLine,
  RiMailLine,
} from 'react-icons/ri';
import { StaticImage } from 'gatsby-plugin-image';

function Footer() {
  const getYear = () => new Date().getFullYear();

  return (
    <div className="lighterGreyBG">
      <Container className="partner-container d-flex align-items-center">
        <Row className="mt-5 mb-5 flex-fill">
          <Col className="d-flex justify-content-center flex-lg-column align-items-center text-center mt-5">
            <StaticImage src="../images/icon.svg" className="partner-logo mt-3 mb-3" alt="Marshmoor Bricks Square Icon" />
          </Col>
        </Row>
      </Container>
      <footer className="footer shadow-12 bg-primary text-white">
        <Container className="mt-5 pt-5 pb-5 text-center text-xl-start">
          <Row className="d-xl-flex justify-content-between border-top border-bottom border-warning border-5 pb-5 mb-5">
            <Col className="d-xl-flex justify-content-xl-middle flex-lg-column pt-5" sm="12" xl="3">
              <div className="me-lg-auto">
                <h4 className="text-warning fw-bold">Contact Us</h4>
                <span className="mt-2 mb-2 smallprint">
                  <a href="tel:+441438869100" className="text-white text-decoration-none">
                    <RiPhoneLine />
                    {' '}
                    01438 869100
                  </a>
                </span>
                <br />
                <span className="mt-2 mb-2 smallprint">
                  <a href="mailto:info@marshmoorbricks.co.uk" className="text-white text-decoration-none">
                    <RiMailLine />
                    {' '}
                    info@marshmoorbricks.co.uk
                  </a>
                </span>
              </div>
            </Col>
            <Col className="d-xl-flex justify-content-xl-middle pt-5" sm="12" xl="3">
              <div className="me-lg-auto ms-lg-auto">
                <h4 className="text-warning fw-bold">Address</h4>
                <span className="mt-2 mb-2 smallprint">
                  Marshmoor Bricks Ltd.
                  <br />
                  44b Walkern road
                  <br />
                  Benington
                  <br />
                  Nr. Stevenage
                  <br />
                  Herts
                  <br />
                  SG2 7LP
                </span>
              </div>
            </Col>
            <Col className="d-xl-flex justify-content-xl-middle pt-5" sm="12" xl="3">
              <div className="me-lg-auto ms-lg-auto">
                <h4 className="text-warning fw-bold">Resources</h4>
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/resources/brick-calculator/" className="text-white text-decoration-none">Brick Calculator</Link>
                </span>
                <br />
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/resources/cpd-presentation/" className="text-white text-decoration-none">CPD Presentation</Link>
                </span>
                <br />
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/resources/brick-match/" className="text-white text-decoration-none">Brick Match Service</Link>
                </span>
                <br />
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/bricks/" className="text-white text-decoration-none">Brick Catalogue</Link>
                </span>
                <br />
              </div>
            </Col>
            <Col className="d-xl-flex justify-content-xl-middle flex-lg-column pt-5" sm="12" xl="3">
              <div className="ms-lg-auto">
                <h4 className="text-warning fw-bold">Your Business</h4>
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/business/architects/" className="text-white text-decoration-none">Architects</Link>
                </span>
                <br />
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/business/builders-merchants/" className="text-white text-decoration-none">Builders&apos; Merchants</Link>
                </span>
                <br />
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/business/builders/" className="text-white text-decoration-none">Builders</Link>
                </span>
                <br />
                <span className="mt-2 mb-2 smallprint">
                  <Link to="/business/contractors/" className="text-white text-decoration-none">Contractors</Link>
                </span>
                <br />
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="d-xl-flex justify-content-xl-center mt-2">
              <SocialLinks />
            </Col>
          </Row>
          <Row>
            <Col className="d-xl-flex justify-content-xl-center pt-5 ps-2 pe-2 text-center">
              <span className="mt-2 mb-2 smallprint" id="copyright">
                <RiCopyrightLine />
                {' '}
                {getYear()}
                {' '}
                Marshmoor Bricks LTD.
                {' '}
                <br />
                {' '}
                All Rights Reserved.
              </span>
            </Col>
          </Row>
          <Row>
            <Col className="d-xl-flex justify-content-xl-center flex-column pt-5 ps-2 pe-2 text-center">
              <span className="mt-2 mb-2 smallprint text-underline">
                <Link to="/privacy-policy/" className="text-white text-decoration-none"><u>Privacy</u></Link>
              </span>
              <br />
              <span className="mt-2 mb-2 smallprint text-underline">
                <Link to="/returns/" className="text-white text-decoration-none"><u>Returns</u></Link>
              </span>
              <br />
              <span className="mt-2 mb-2 smallprint text-underline">
                <a href="/terms_and_conditions_of_sale.pdf" className="text-white text-decoration-none" target="_blank" rel="noopener noreferrer"><u>Terms & Conditions</u></a>
              </span>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
}

function SocialLinks() {
  return (
    <a href="https://www.linkedin.com/company/marshmoor-bricks-limited" className="text-white">
      <RiLinkedinBoxLine size="1.75em" />
    </a>
  );
}

export default Footer;
